import { render } from "./TransactionDetailModal.vue?vue&type=template&id=23a61e42&scoped=true"
import script from "./TransactionDetailModal.vue?vue&type=script&lang=js"
export * from "./TransactionDetailModal.vue?vue&type=script&lang=js"

import "./TransactionDetailModal.vue?vue&type=style&index=0&id=23a61e42&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23a61e42"]])

export default __exports__